/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module CompaniontoolTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface CompanionToolRequest {
    [k: string]: any;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "LogCollectionResult".
 */
export interface LogCollectionResult {
    downloadLocation: string;
    statusCode: number;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "LoadParameters".
 */
export interface LoadParameters {
    filename: string;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "SaveParameters".
 */
export interface SaveParameters {
    filename: string;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "ResetParameters".
 */
export interface ResetParameters {
    preLoadReset: boolean;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "Run_Log_CollectorReturn".
 */
export interface Run_Log_CollectorReturn {
    logCollectionResult: LogCollectionResult;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "Download_Internal_Override_ToolReturn".
 */
export interface Download_Internal_Override_ToolReturn {
    statusCode: IotUpdateStatus;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "Get_Latest_UrlReturn".
 */
export interface Get_Latest_UrlReturn {
    url: string;
}
/**
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "Update_Internal_Override_ToolReturn".
 */
export interface Update_Internal_Override_ToolReturn {
    statusCode: IotUpdateStatus;
}

/**
 * Status returned by internal override tool update routines
 *
 * This interface was referenced by `CompanionToolRequest`'s JSON-Schema
 * via the `definition` "IOTUpdateStatus".
 */
export enum IotUpdateStatus {
    Success = 'Success',
    SuccessArchiveExists = 'SuccessArchiveExists',
    SuccessNeedsRestart = 'SuccessNeedsRestart',
    FailureGeneric = 'FailureGeneric'
}


}
